import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const C = {
  h1: (p) => <h3 className="mb-3 mt-6 text-xl font-bold text-zinc-50" {...p} />,
  h2: (p) => <h3 className="mb-3 mt-6 text-lg font-bold text-zinc-50" {...p} />,
  h3: (p) => <h4 className="mb-2 mt-5 text-base font-semibold text-zinc-100" {...p} />,
  h4: (p) => <h5 className="mb-2 mt-4 text-[15px] font-semibold text-zinc-100" {...p} />,
  p: (p) => <p className="my-3 leading-relaxed text-zinc-300" {...p} />,
  strong: (p) => <strong className="font-semibold text-zinc-50" {...p} />,
  ul: (p) => <ul className="my-3 list-disc space-y-1.5 pl-5 text-zinc-300 marker:text-blue-500" {...p} />,
  ol: (p) => <ol className="my-3 list-decimal space-y-1.5 pl-5 text-zinc-300 marker:text-blue-400" {...p} />,
  li: (p) => <li className="leading-relaxed" {...p} />,
  a: ({ href, ...p }) => <a href={href} target="_blank" rel="noreferrer" className="text-blue-400 underline-offset-2 hover:underline" {...p} />,
  blockquote: (p) => <blockquote className="my-4 rounded-r-lg border-l-2 border-[#FFCC00] bg-[#FFCC00]/[0.06] px-4 py-1 text-zinc-200" {...p} />,
  table: (p) => <div className="my-4 overflow-x-auto rounded-lg border border-zinc-800"><table className="w-full min-w-[520px] text-left text-[13px]" {...p} /></div>,
  thead: (p) => <thead className="bg-zinc-900 text-zinc-200" {...p} />,
  th: (p) => <th className="border-b border-zinc-800 px-3 py-2 font-semibold" {...p} />,
  td: (p) => <td className="border-b border-zinc-800/60 px-3 py-2 align-top text-zinc-300" {...p} />,
  code: (p) => <code className="rounded bg-zinc-800 px-1.5 py-0.5 text-[0.9em] text-zinc-100" {...p} />,
  hr: () => <hr className="my-6 border-zinc-800" />,
};

export function Md({ children, className = "" }) {
  return (
    <div className={`text-[15px] ${className}`}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={C}>{children || ""}</ReactMarkdown>
    </div>
  );
}
